import { useState } from "react";
import DownloadFormatMenu from "../../../../components/ui/download/DownloadFormatMenu";
import BackLink from "../../../../components/ui/pageNavigation/BackLink";
import { ExportFormat } from "../../../../api/download";

interface InternalReportContainerProps {
  title: string;
  backHref?: string;
  backLabel?: string;
  onDownload: (format: ExportFormat) => void | Promise<void>;
  downloadEnabled?: boolean;
  children: React.ReactNode;
}

const InternalReportContainer = ({
  title,
  backHref = "/internal-reports",
  backLabel = "Back to Reports",
  onDownload,
  downloadEnabled = true,
  children,
}: InternalReportContainerProps) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleSelect = async (format: ExportFormat) => {
    if (isDownloading) return;
    setIsDownloading(true);
    try {
      await onDownload(format);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <BackLink text={backLabel} href={backHref} />
      <div className="overflow-hidden rounded-xl bg-white shadow-sm">
        <div className="relative z-10 flex items-center justify-between gap-4 bg-[#F9FAFB] px-6 py-4">
          <h2 className="truncate text-lg font-medium leading-7 text-[#0A0A0A]">{title}</h2>
          <DownloadFormatMenu
            variant="button"
            onSelect={handleSelect}
            disabled={!downloadEnabled}
            loading={isDownloading}
          />
        </div>
        <div className="px-6 py-6">{children}</div>
      </div>
    </div>
  );
};

export default InternalReportContainer;
